import { css } from 'linaria';

export const productPriceWrapper = css`
  margin-bottom: 8px;
`;


export const productPrice = css`
  && {
    font-weight: 700;
    font-family: LMNA, Roboto, apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell,
      'Open Sans', 'Helvetica Neue', sans-serif;
  }
`;

export const productPriceCurrency = css`
  && {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const productPriceCredit = css`
  && {
    width: max-content;
    height: 24px;
    padding: 3px 5px;
    margin-bottom: 8px;
    border: 1px solid var(--control-minor);
    border-radius: var(--rounding-m);
  }
`;

export const productPriceContainer = css`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
